import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { UploadedFileViewModel, DocumentModule } from 'src/app/components/core/components/uploader/document_uploader.types';
import { DocumentoUICamViewModel } from '../../unidad-inspeccion-datosbasicos.types';
import { ConfigurationService } from '../../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-documento-ui-edit',
    templateUrl: './documento-ui-edit.component.html',
    styleUrls: ['./documento-ui-edit.component.scss'],
})
export class DocumentoUiEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() formGroup: FormGroup;
    @Input() readonly: boolean;
    @Input() IdUiCam: number;
    @Input() documentoUI: DocumentoUICamViewModel;
    @Input() submitted: boolean;
    @Input() requerirObservaciones: boolean;
    @Output() fileUpload = new EventEmitter<DocumentoUICamViewModel>(); // En caso que el usuario no guardara la documentación vinculada al fichero adjuntado, el fichero tendrá que ser eliminado de la BD.

    editMode = false;
    editTitle = 'Nuevo';

    uploadedFile: UploadedFileViewModel = new UploadedFileViewModel();
    documentModuleCampania = DocumentModule.Campania;
    megaSizeLimit = 0;

    private fileSuccessMessage = 'Documentación cargada. Recuerde GUARDAR antes de abandonar la pantalla';

    constructor(
        public datepipe: DatePipe,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private cdr: ChangeDetectorRef,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);
    }

    ngOnInit(): void {
        this.updateForm();
        this.MegaSizeLimitsCargado$.subscribe(() => {
            this.megaSizeLimit = this.getValorSizeLimit('documento-ui-edit');
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.documentoUI?.currentValue) {
            this.documentoUI = { ...changes.documentoUI.currentValue };
            this.uploadedFile = {
                ...this.uploadedFile,
                Guid: this.documentoUI?.CodigoStorage,
                Name: this.documentoUI?.NombreArchivo,
                Size: this.documentoUI?.FileSize,
            };

            this.updateForm();
        }
    }

    /**
     * This functions sets the values in the documento (@Input) into the form.
     */
    private updateForm(): void {
        if (!this.formGroup) {
            return;
        }
        if (this.documentoUI) {
            this.formGroup.setValue({
                Descripcion: this.documentoUI?.Descripcion,
                NombreArchivo: this.documentoUI != null ? this.documentoUI.NombreArchivo : null,
            });
        }
        this.form = this.formGroup; // componentBase uses this.form

        if (this.readonly) {
            this.formGroup.controls['Descripcion'].disable();
        }
        this.cdr.detectChanges();
    }

    onFileUploaded(uploadedFile: UploadedFileViewModel): void {
        this.documentoUI = new DocumentoUICamViewModel();
        this.documentoUI.IdUnidadInspeccion = this.IdUiCam;
        this.documentoUI.CodigoStorage = uploadedFile.Guid;
        this.documentoUI.NombreArchivo = uploadedFile.Name;
        this.documentoUI.FileSize = uploadedFile.Size;
        this.documentoUI.IdUsuario = this.loggedInUser!.Id;

        this.addSuccessMessage(this.fileSuccessMessage);

        this.fileUpload.emit(this.documentoUI);
    }

    onFileDeleted(uploadedFile: UploadedFileViewModel): void {
        // DO NOTHING
    }
}
